module.exports = __webpack_public_path__ + "images/notfound_3acf5c9.svg";